import React from "react";
import FooterSection from "../../components/sections/FooterSection";

function MekgrajPartnerPage(props)
{
    return (
        <>
            <div 
                className="uk-section uk-section-default uk-padding-large"
                data-uk-scrollspy="cls: uk-animation-fade; target: > div; delay: 200; repeat: false"
            >
                <div className="uk-container uk-container-small">

                    <div className="uk-card uk-card-default uk-card-body uk-box-shadow-large uk-padding-large uk-margin-large-bottom">

                        <h1 className="uk-heading-medium uk-text-center uk-margin-large-bottom">
                            To our Nigerian Clients
                        </h1>

                        <p className="uk-text-lead uk-margin-large-bottom uk-text-justify">
                            If Nigerian nationals, or if long-term residency in Nigeria applies, and the intention is to visit Kazakhstan, 
                            this service is available through the official partners, Mekgraj International.
                        </p>

                        <div className="uk-text-center uk-margin-large-bottom">
                            <img 
                                src="/imgvideo/mekgraj.jpg" 
                                className="uk-border-rounded uk-box-shadow-medium"
                                style={{ maxWidth: "100%", height: "auto" }}
                                data-uk-scrollspy="cls: uk-animation-scale-up; repeat: false"
                            />
                        </div>

                        <div className="uk-flex uk-flex-center uk-margin-large-top">
                            <a 
                                href="https://mekgrajinternational.com/" 
                                className="uk-button uk-button-jai uk-button-large"
                                data-uk-scrollspy="cls: uk-animation-slide-bottom-small; repeat: false"
                            >
                                Click here
                            </a>
                        </div>

                    </div>

                </div>
            </div>

            <FooterSection />
        </>
    );
}

export default MekgrajPartnerPage;
